// Generazione di un file .ics (iCalendar) per un appuntamento, scaricato nel
// browser del paziente. Nessun servizio esterno, nessun account, nessuna quota:
// il file è creato lato client e viene aperto dall'app calendario del telefono
// (Apple Calendar, Google Calendar, Outlook, ...).

const pad = (n) => String(n).padStart(2, '0');

// Data/ora in formato LOCALE "floating" (senza Z e senza TZID): il calendario
// del paziente lo interpreta nel proprio fuso (Europe/Rome per gli utenti IT).
const formatLocalFloating = (d) =>
  `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}T${pad(d.getHours())}${pad(d.getMinutes())}${pad(d.getSeconds())}`;

// Data/ora in UTC con Z, per DTSTAMP.
const formatUtc = (d) =>
  `${d.getUTCFullYear()}${pad(d.getUTCMonth() + 1)}${pad(d.getUTCDate())}T${pad(d.getUTCHours())}${pad(d.getUTCMinutes())}${pad(d.getUTCSeconds())}Z`;

// Escape dei caratteri speciali nei valori di testo iCalendar (RFC 5545).
const escapeText = (s = '') =>
  String(s)
    .replace(/\\/g, '\\\\')
    .replace(/;/g, '\\;')
    .replace(/,/g, '\\,')
    .replace(/\r?\n/g, '\\n');

// Costruisce il contenuto .ics per un appuntamento.
//   dateString: "YYYY-MM-DD", time: "HH:MM", title: testo del SUMMARY.
// Evento a orario singolo: solo DTSTART, nessun DTEND/durata, nessun luogo,
// telefono o descrizione (per scelta di progetto).
// Promemoria (1 giorno + 1 ora prima) inclusi SOLO se l'appuntamento è a più di
// 25 ore da adesso (momento della prenotazione): sotto quella soglia un avviso
// "1 giorno prima" cadrebbe nel passato ed è inutile.
export const buildAppointmentIcs = ({ dateString, time, title, now = new Date() }) => {
  const [y, m, d] = dateString.split('-').map(Number);
  const [hh, mm] = time.split(':').map(Number);
  const start = new Date(y, m - 1, d, hh, mm, 0);

  const hoursUntil = (start.getTime() - now.getTime()) / 3600000;
  const withReminders = hoursUntil > 25;

  const uid = `${dateString}-${time.replace(':', '')}-${now.getTime()}@ped-booking`;

  const lines = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//ped-booking//IT',
    'CALSCALE:GREGORIAN',
    'METHOD:PUBLISH',
    'BEGIN:VEVENT',
    `UID:${uid}`,
    `DTSTAMP:${formatUtc(now)}`,
    `DTSTART:${formatLocalFloating(start)}`,
    `SUMMARY:${escapeText(title)}`
  ];

  if (withReminders) {
    lines.push(
      'BEGIN:VALARM',
      'ACTION:DISPLAY',
      'DESCRIPTION:Promemoria appuntamento',
      'TRIGGER:-P1D',
      'END:VALARM',
      'BEGIN:VALARM',
      'ACTION:DISPLAY',
      'DESCRIPTION:Promemoria appuntamento',
      'TRIGGER:-PT1H',
      'END:VALARM'
    );
  }

  lines.push('END:VEVENT', 'END:VCALENDAR');
  return lines.join('\r\n');
};

// Scarica il contenuto .ics come file. Su iPhone/Android l'apertura del file
// propone di aggiungere l'evento al calendario di sistema.
export const downloadIcs = (filename, icsContent) => {
  const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};
